import request from '@/utils/request';

const baseURL = process.env.VUE_APP_SORTING;

/**
 * 分页查询分拣记录
 * @param {Object} data - 查询参数
 * @param {number} data.pageNumber - 页码
 * @param {number} data.pageSize - 每页条数
 * @param {Object} data.params - 筛选条件
 * @returns {Promise}
 */
export function getSortingRecordPage(data) {
  return request({
    baseURL: baseURL,
    url: '/record/page',
    method: 'post',
    data
  });
}

/**
 * 运单落格测算
 * @param {Object} data - 测算参数
 * @param {string} data.machineCode - 分拣机编码
 * @param {Array<string>} [data.waybillNumberList] - 运单号列表
 * @param {Array<string>} [data.scanNumberList] - 扫描单号列表
 * @returns {Promise}
 */
export function measureSortingRecord(data) {
  return request({
    baseURL: baseURL,
    url: '/record/measure',
    method: 'post',
    data
  });
}

// 新分拣记录导出
export const getSortingRecordExport = (data) => {
  return request({
    url: '/record/export',
    method: 'post',
    data,
    baseURL: baseURL
  });
};
// dws称重导出
export const weighingRecordExportAll = (data) => {
  return request({
    url: '/weighingRecord/exportAll',
    method: 'post',
    data,
    baseURL: baseURL
  });
};
// 落袋记录导出
export const uploadRecordExportAll = (data) => {
  return request({
    url: '/uploadRecord/exportAll',
    method: 'post',
    data,
    baseURL: baseURL
  });
};
